module.exports = __webpack_public_path__ + "img/opening-act-2.9ed94011.jpg";